import { render, staticRenderFns } from "./NavigationDrawerNavPanel.vue?vue&type=template&id=bc5df06c&scoped=true"
import script from "./NavigationDrawerNavPanel.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerNavPanel.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerNavPanel.vue?vue&type=style&index=0&id=bc5df06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5df06c",
  null
  
)

export default component.exports